export default "/fonts/vendor/@fontsource/lato/files/lato-latin-100-normal.woff2?6219d77f765dee38fd8704eedfa56801";